import { render, staticRenderFns } from "./UploadingFile.vue?vue&type=template&id=2aea9945&scoped=true&"
import script from "./UploadingFile.vue?vue&type=script&lang=ts&"
export * from "./UploadingFile.vue?vue&type=script&lang=ts&"
import style0 from "./UploadingFile.vue?vue&type=style&index=0&id=2aea9945&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aea9945",
  null
  
)

export default component.exports